/**
 * useInteractionMode Hook
 * Centralizes interactionMode-based UI gating for students.
 *
 * When interactionMode === 'rep-counselor':
 *   - Student cannot create/submit service requests
 *   - Student cannot upload documents
 *   - Student cannot submit tasks
 *   - Student cannot send chat messages
 *   - Student sees "Managed by representative" notice
 *
 * When interactionMode === 'student-counselor' (or null):
 *   - Normal student behavior
 *
 * For non-student roles, all actions are allowed (role-based gating is separate).
 */

import { useAuth } from '../context/AuthContext';

export function useInteractionMode() {
  const { user } = useAuth();

  // Only applies to students
  if (!user || user.role !== 'student') {
    return {
      interactionMode: null,
      isRepManaged: false,
      canCreateServiceRequest: true,
      canUploadDocuments: true,
      canSubmitTasks: true,
      canSendMessages: true,
      canApplyServices: true
    };
  }

  const student = JSON.parse(localStorage.getItem('student') || '{}');
  const mode = student.interactionMode || 'student-counselor';
  const isRepManaged = mode === 'rep-counselor';

  return {
    interactionMode: mode,
    isRepManaged,
    canCreateServiceRequest: !isRepManaged,
    canUploadDocuments: !isRepManaged,
    canSubmitTasks: !isRepManaged,
    canSendMessages: !isRepManaged,
    canApplyServices: !isRepManaged
  };
}
